export default __webpack_public_path__ + "static/media/white-logo.23da22ff.svg";